export default __webpack_public_path__ + "static/follow-cd3bb7947931d45da1ab90f84c596160.svg";